import { render, staticRenderFns } from "./CoreLoader.vue?vue&type=template&id=90af976c&"
import script from "./CoreLoader.vue?vue&type=script&lang=js&"
export * from "./CoreLoader.vue?vue&type=script&lang=js&"
import style0 from "./CoreLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports